import { render, staticRenderFns } from "./edit-shiti.vue?vue&type=template&id=576c8d85&scoped=true&"
import script from "./edit-shiti.vue?vue&type=script&lang=ts&"
export * from "./edit-shiti.vue?vue&type=script&lang=ts&"
import style0 from "./edit-shiti.vue?vue&type=style&index=0&id=576c8d85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c8d85",
  null
  
)

export default component.exports